/* eslint-disable no-shadow */
/*
 *
 * OnDemandSettlements reducer
 *
 */
import produce from 'immer';
import moment from 'moment';

import {
  DEFAULT_PG_MENU_TAB_STATE,
  DEFAULT_CURRENT_PAGE,
} from '../../utils/constants';

import {
  DEFAULT_ACTION,
  UPDATE_TABLE_DATA,
  SAVE_SETTLEMENTS,
  ENABLE_LOADER,
  DISABLE_LOADER,
  UPDATE_FILTERS,
  RESET_FILTERS,
  RESET_PAGE,
  RESET_DATA,
  UPDATE_SETTLEMENT_HOLIDAYS,
  UPDATE_UNSETTLED_AMOUNT,
  UPDATE_ELIGIBLE_FUNDS,
} from './constants';

const getInitialState = () => ({
  isLoading: false,
  ...DEFAULT_PG_MENU_TAB_STATE,
  holidaysData: {},
  unSettledAmountData: {
    unSettledAmount: null,
    lastUpdatedAt: '',
  },
  eligibleFundsData: {
    eligibleFunds: null,
    lastUpdatedAt: '',
  },
  settlementsTemplateType: '',
});

export const initialState = {
  pagination: {},
  ...getInitialState(),
};

/* eslint-disable default-case, no-param-reassign */
const onDemandSettlementsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SAVE_SETTLEMENTS: {
        const { data } = action.payload;
        draft.data = data.content;
        draft.isLoading = false;
        break;
      }
      case UPDATE_TABLE_DATA: {
        const {
          totalCount,
          currentPageRowData,
          hasPrevEnabled,
          hasNextEnabled,
        } = action.data;
        draft.totalCount = totalCount;
        draft.hasPrev = hasPrevEnabled;
        draft.hasNext = hasNextEnabled;
        draft.currentPageRowData = currentPageRowData;
        break;
      }
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      case UPDATE_FILTERS: {
        const { data } = action;
        const {
          activeNavigation,
          appliedFilters,
          dateFilters,
          filtersForDisplay,
          ...filters
        } = data;
        if (appliedFilters) {
          draft.filters.appliedFilters = appliedFilters;
        }
        if (dateFilters) draft.filters.dateFilters = dateFilters;
        draft.filters = {
          ...draft.filters,
          ...filters,
        };
        if (filtersForDisplay) {
          draft.filtersForDisplay = filtersForDisplay;
        }
        break;
      }
      case RESET_FILTERS: {
        const { dateFilters } = draft.filters;

        if (dateFilters) {
          const { range } = dateFilters;
          draft.filters.appliedFilters = {
            ...initialState.filters.appliedFilters,
            startDate: moment(range[0]).format('YYYY-MM-DD 00:00:00'),
            endDate: moment(range[1])
              .endOf('day')
              .format('YYYY-MM-DD HH:mm:ss'),
          };
        } else {
          draft.filters.appliedFilters = {
            ...initialState.filters.appliedFilters,
          };
        }
        draft.filtersForDisplay = initialState.filtersForDisplay;
        break;
      }
      case UPDATE_SETTLEMENT_HOLIDAYS: {
        draft.holidaysData = action.data || {};
        break;
      }
      case RESET_PAGE: {
        draft.filters.pageNo = DEFAULT_CURRENT_PAGE;
        break;
      }
      case RESET_DATA: {
        const obj = getInitialState();
        Object.keys(obj).forEach(k => (draft[k] = obj[k])); // eslint-disable-line
        break;
      }
      case UPDATE_UNSETTLED_AMOUNT: {
        const { unsettledAmount } = action.data;
        draft.unSettledAmountData.unSettledAmount =
          unsettledAmount > 0 ? unsettledAmount : 0;
        draft.unSettledAmountData.lastUpdatedAt = moment().format('hh:mm A');
        break;
      }
      case UPDATE_ELIGIBLE_FUNDS: {
        const { eligibleFunds } = action.data;
        draft.eligibleFundsData.eligibleFunds =
          eligibleFunds > 0 ? eligibleFunds : 0;
        draft.eligibleFundsData.lastUpdatedAt = moment().format('hh:mm A');
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default onDemandSettlementsReducer;
